import React, { useEffect, useState, useRef } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import parse, { domToReact } from "html-react-parser";
import { motion } from "framer-motion/dist/framer-motion";
import SequenceShow from '../partials/SequenceShow';

export default function Home() {
  const location = useLocation();
  const hash = location.hash;
  const [page, setPage] = useState();
  const [content, setContent] = useState();
  const [isLoading, setLoading] = useState(true);
  const contentContainer = useRef(null);
  
  const parserOptions = {
    replace: ({ attribs, children }) => {
      if (!attribs || !children) {
        return;
      }
      if ( attribs && attribs.class === 'animated-words' && children) {
        let validChildren = children.filter( child => child.type !== 'text')
        return <SequenceShow>{domToReact(validChildren, parserOptions)}</SequenceShow>;
      }
    }
  }

  useEffect(() => {
    let _lang = hash ? hash.replace("#", "").toLocaleLowerCase() : 'fr';
    const fetchPage = async () => {
      const data = await fetch(`https://bigl-architectes.fr/wp-json/wp/v2/pages/2?lang=${_lang}`);
      const _page = await data.json();
      _page.translations[_lang] && _page.translations[_lang]["content"] 
        ? setContent( _page.translations[_lang]["content"] ) 
        : setContent( _page.content.rendered );
      setPage(_page);
      setLoading(false);
    }
    fetchPage().catch(console.error);
  }, [hash]);
  
  return ( !isLoading && (
    <>
      <motion.div
        id="home-motion"
        key="home-motion"
        initial={ false }
        exit={{ zIndex:0, transition:{duration: 0, delay: 2} }}
      >
        <div id="home" role="main" initial="false" className={ location.pathname !== "/" ? "hidden-small" : "" } >
          <div className="post-content" ref={contentContainer}>{parse(content, parserOptions)}</div>
        </div>
      </motion.div> 

      <Outlet/>
    </>
  ) );
}
